import { connect } from "react-redux";
import _ from "lodash";

import AssetShareAnalyticsView from "./view";
import { fetchPreviewAsset } from "src/legacy/redux/actions/assets.jsx";
import { fetchAssetAnalytics } from "src/legacy/redux/actions/conversations";
import withUseHooks from "src/legacy/components/withUseHooks";

const mapStateToProps = (state, ownProps) => {
  var share = _.get(state.legacyRootReducer, `conversations.conversation.item[${_.get(ownProps, 'location.query.share', null)}]`);
  if (!share) {
    return;
  }

  if (share) {
    share = share.item
  }


  const section = share?.sections?.length && share.sections.find((section) => {
    if (section.id == _.get(ownProps, 'location.query.section', null)) {
      return section;
    }
  });

  if (section) {
    var asset = section?.assets?.length && section?.assets.find((asset) => {
      return asset.id == _.get(ownProps, 'location.query.asset', null);
    });
  } else {
    var asset = share?.assets?.length &&
    share.assets.find((asset) => {
      if (asset?.id == _.get(ownProps, 'location.query.asset', null)) {
        return asset;
      }
    });
  }
  return {
    asset: asset,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAssetAnalytics: (shareID, sectionID, assetID) => {
      return dispatch(
        fetchAssetAnalytics(shareID, sectionID, assetID)
      );
    },
    fetchPreviewAsset: (assetID) => {
      return dispatch(fetchPreviewAsset(assetID));
    },
  };
};

const OpportunityAssetShareAnalyticsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(AssetShareAnalyticsView);

export default withUseHooks(OpportunityAssetShareAnalyticsContainer);